/**
 * Variant swatch label sync
 *
 * When a customer clicks an in-stock variant swatch (.input-swatch.variant-selector),
 * update the visible selected-value labels (.option_value) to the swatch's variant
 * title, and reflect the chosen variant in the URL.
 *
 * Note: the theme's native product-options component updates the hidden
 * .js-product-option-value element, not the visible .option_value shown in the
 * variant selector legend / rating container, so this small handler is what keeps
 * that visible label in sync.
 */
window.addEventListener("DOMContentLoaded", () => {
  document
    .querySelectorAll(".input-swatch.variant-selector")
    .forEach((variantSelector) => {
      variantSelector.addEventListener("click", (e) => {
        const label = e.target.closest("label");

        var weight_element = e.target.closest('.product-options__option').querySelector('.option_value');
        var other_variant_selector = document.querySelector('.rating__container .option_value');
        var stock_element = e.target.closest('.out-of-stock');

        if (stock_element == null) {
          if (weight_element) {
            weight_element.innerHTML = variantSelector.dataset.variantTitle;
          }
          if (other_variant_selector) {
            other_variant_selector.innerHTML = variantSelector.dataset.variantTitle;
          }
          if (label) {
            const variantId = label.getAttribute("data-variant-id");

            const url = new URL(window.location.href);
            url.searchParams.set("variant", variantId);
            window.history.pushState({}, "", url);
          }
        }
      });
    });
});
